import { Mail, Phone, MapPin, Globe, Compass } from "lucide-react";
import { Reveal } from "./Reveal";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "blueprint", label: "Blueprint" },
  { id: "capabilities", label: "Capabilities" },
  { id: "values", label: "Values" },
  { id: "leadership", label: "Leadership" },
  { id: "contact", label: "Contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden" aria-label="Footer">
    <div
      className="absolute inset-0 bg-cover bg-[center_bottom]"
      style={{ backgroundImage: "url(/assets/blueprint-art.png)" }}
      aria-hidden="true"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy/70 to-navy/40" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 pb-10 pt-24 sm:px-6 sm:pt-32 lg:px-8">
      <Reveal className="text-center">
        <img src="/assets/vhe-logo.png" alt="" aria-hidden="true" className="mx-auto mb-12 h-40 w-auto drop-shadow-[0_0_40px_rgba(212,175,55,0.55)] sm:h-72" />
        <p className="font-cormorant text-3xl font-semibold italic leading-snug text-transparent sm:text-5xl lg:text-6xl" data-testid="footer-tagline">
          <span className="gold-text">Architecting the Framework of the Future!</span>
        </p>
        <div className="gold-rule mx-auto mt-10 max-w-md" aria-hidden="true" />
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-col items-center justify-center gap-6 text-center sm:flex-row sm:gap-10" data-testid="footer-contact-row">
          <a href="mailto:info@vhesolutionsllc.org" data-testid="footer-email-link" className="group flex items-center gap-2.5 text-sm text-parchment/90 transition-colors hover:text-goldlight">
            <Mail className="h-4 w-4 text-gold" strokeWidth={1.6} /> info@vhesolutionsllc.org
          </a>
          <a href="https://vhesolutionsllc.org" target="_blank" rel="noopener noreferrer" data-testid="footer-website-link" className="group flex items-center gap-2.5 text-sm text-parchment/90 transition-colors hover:text-goldlight">
            <Globe className="h-4 w-4 text-gold" strokeWidth={1.6} /> vhesolutionsllc.org
          </a>
          <a href="tel:+15057887377" data-testid="footer-phone-link" className="group flex items-center gap-2.5 text-sm text-parchment/90 transition-colors hover:text-goldlight">
            <Phone className="h-4 w-4 text-gold" strokeWidth={1.6} /> (505) 788-7377
          </a>
          <span className="flex items-center gap-2.5 text-sm text-parchment/90" data-testid="footer-address">
            <MapPin className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.6} /> 1209 Mountain Road Pl NE, Ste. N, Albuquerque, NM 87110
          </span>
        </div>
      </Reveal>

      <nav aria-label="Footer" className="mt-12 flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
        {LINKS.map((l) => (
          <a
            key={l.id}
            href={`#${l.id}`}
            data-testid={`footer-link-${l.id}`}
            className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-400 transition-colors duration-300 hover:text-gold"
          >
            {l.label}
          </a>
        ))}
      </nav>

      <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
        <p className="text-xs text-slate-400" data-testid="footer-copyright">© 2026 Vision-Heirs Enterprises Holdings, LLC. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500" aria-hidden="true">Sheet VHE-2026 · Rev A · Drawn to scale 1:1</p>
          <a href="/admin" data-testid="footer-admin-link" className="group inline-flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.3em] text-slate-500 transition-colors duration-300 hover:text-gold">
            <Compass className="h-3 w-3 transition-transform duration-500 group-hover:rotate-45" aria-hidden="true" />
            Admin
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
